export const displayValue = value => {
  if (value === null || value === undefined || value === '') return '-';
  return value;
};

export const formatSubmittedDate = isoDate => {
  if (!isoDate) return '-';
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return '-';
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(date);
};

export const getProcurementStatusConfig = status => {
  const statusCode =
    status === '' || status === null || status === undefined
      ? 0
      : Number(status);

  switch (statusCode) {
    case 1:
      return {
        label: 'Confirmed',
        className: 'bg-success text-light',
      };
    case 0:
    default:
      return {
        label: 'Open',
        className: 'bg-info text-light',
      };
  }
};
